import React from "react";
import {Route, Routes as Switch} from "react-router-dom";
import NotFound from "./error/NotFound";
import EventoDetalhePage from "./eventos-detalhes/EventoDetalhePage";
import EventosPage from "./eventos/EventosPage";
import DashboardEnviosPage from "./dashboard/DashboardEnviosPage";
import IntegracaoFinanceiraPage from "./integracao-financeira/IntegracaoFinanceiraPage";
import IntegracaoFolhaPage from "./integracao-folha/IntegracaoFolhaPage";
import ServicosGeraisPage from "./servicos-gerais/ServicosGeraisPage";
import RoleGate from "./RoleGate";
import {ROLES_ESFINGE} from "../shared/keycloak";

const ROLES_COMPARTILHADAS = [
    ROLES_ESFINGE.MASTER,
    ROLES_ESFINGE.FOLHA,
    ROLES_ESFINGE.FINANCEIRA
];
const ROLES_FOLHA = [ROLES_ESFINGE.MASTER, ROLES_ESFINGE.FOLHA];
const ROLES_FINANCEIRA = [ROLES_ESFINGE.MASTER, ROLES_ESFINGE.FINANCEIRA];

function Routes() {
    return (
        <Switch>
            <Route path="*" element={<NotFound />} />
            <Route
                path="/"
                element={
                    <RoleGate roles={ROLES_COMPARTILHADAS}>
                        <EventosPage />
                    </RoleGate>
                }
            />
            <Route
                path="/eventos/:id"
                element={
                    <RoleGate roles={ROLES_COMPARTILHADAS}>
                        <EventoDetalhePage />
                    </RoleGate>
                }
            />
            <Route
                path="/dashboard"
                element={
                    <RoleGate roles={ROLES_COMPARTILHADAS}>
                        <DashboardEnviosPage />
                    </RoleGate>
                }
            />
            <Route
                path="/integracao-financeira"
                element={
                    <RoleGate roles={ROLES_FINANCEIRA}>
                        <IntegracaoFinanceiraPage />
                    </RoleGate>
                }
            />
            <Route
                path="/integracao-folha"
                element={
                    <RoleGate roles={ROLES_FOLHA}>
                        <IntegracaoFolhaPage />
                    </RoleGate>
                }
            />
            <Route
                path="/servicos-gerais"
                element={
                    <RoleGate roles={ROLES_COMPARTILHADAS}>
                        <ServicosGeraisPage />
                    </RoleGate>
                }
            />
        </Switch>
    );
}

export default Routes;
